module.exports = __webpack_public_path__ + "static/media/5.19ed2a38.svg";